import Axios from "axios";

export const emailService = {
  sendMail
};

async function sendMail(simulationId, name, surname, email, privacy, profile) {
  const data = new FormData();
  data.append("name", name);
  data.append("surname", surname);
  data.append("email", email);
  data.append("privacy", privacy);
  data.append("profile", profile);

  const config = {
    // transformRequest: angular.identity,
    headers: {
      "Content-Type": undefined,
    },
    withCredentials: true
  };
  return await Axios.post(
    `${process.env.VUE_APP_API_URL}/api/v1/insurances/${process.env.VUE_APP_SIMULATOR_CODE}/simulations/${simulationId}/send`,
    data,
    config
  );

}
